import { z } from "@/zod";
import { PESEL_REGEX } from "@/constants";
import { validatePeselData } from "./peselValidation";
import { Gender } from "@/types/common";
import { t } from "i18next";

export const pesel = z
  .string()
  .length(11, t("validation.pesel.length"))
  .regex(PESEL_REGEX, t("validation.pesel.digits"));

/**
 * PESEL validation for forms with related fields
 * Only validates when all required data is provided
 */
export const peselWithValidation = (fieldNames: {
  personalIdNumberField: string;
  birthDateField?: string;
  genderField?: string;
}) => {
  return (data: Record<string, string>, ctx: z.RefinementCtx) => {
    const personalIdNumber = data[fieldNames.personalIdNumberField];
    const birthDate = data[fieldNames.birthDateField || ""];
    const gender = data[fieldNames.genderField || ""] as Gender;

    const errorCode = validatePeselData({
      personalIdNumber,
      birthDate,
      gender,
    });

    if (errorCode) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: [fieldNames.personalIdNumberField],
        message: t(`validation.pesel.${errorCode}`),
      });
    }
  };
};
